
import { v4 as uuidv4 } from 'uuid';

export default class Slot {

    constructor(source) {
        this.initialized = false;
        this.exists = false;
        if (source) {
            this.init(source);
        }
    }

    init(source) {
        // defaults
        this.id = uuidv4();
        this.capacity = 1;
        this.owner = window.App.auth;
        this.guests = [];
        this.recurrences = {
            count: 1
        };
        this.permissions = {
            update: false,
            delete: false,
        }

        // populate from source
        Object.assign(this, source);

        // convert string dates to date object
        this.start = new Date(source.start);
        this.end = new Date(source.end);
        if (source.recurrences) {
            this.recurrences.start = new Date(source.recurrences.start);
            this.recurrences.end = new Date(source.recurrences.end);
        }

        this.initialized = true;
    }

    async fetch(slotId) {
        let response = await axios.get(`/api/v1/reservations/${slotId}`);
        this.init(response.data.data);
        this.exists = true;
    }

    async store() {

        let endpoint = `/api/v1/reservations/resource/${this.resource.id}`;

        try {
            await axios.post(endpoint, this.toJSON())
            return true;
        } catch (error) {
            console.error(error.response);
            return false;
        }
    }

    async update(withFollowing) {

        let endpoint = `/api/v1/reservations/${this.id}`;

        try {

            await axios.patch(endpoint, {
                ...this.toJSON(),
                ignore: this.recurrenceOfSlotId || this.id,
                withFollowing: withFollowing,
            });
            return true;

        } catch (error) {
            console.error(error.response);
            return false;
        }
    }

    async delete(withFollowing) {

        let endpoint = `/api/v1/reservations/${this.id}`;

        try {

            await axios.delete(endpoint, { data: {
                ...this.toJSON(),
                withFollowing: withFollowing
            }});
            return true;

        } catch (error) {
            console.error(error.response);
            return false;
        }
    }

    isRecurrence() {
        return this.recurrenceOf !== undefined;
    }

    addWeeks(count) {
        this.start.addWeeks(count);
        this.end.addWeeks(count);
        return this;
    }

    toJSON() {
        return {
            id: this.id,
            recurrenceOfSlotId: this.recurrenceOfSlotId,
            project_id: this.project?.id,
            start: this.start.toYmdHisString(),
            end: this.end.toYmdHisString(),
            recurrenceCount: this.recurrences.count,
            capacity: this.capacity,
            guests: this.guestEmails,
        }
    }
}
